import { Component, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { CommonModule } from '@angular/common';

import { CommodityOfferLabels } from '../../../commodity-offers.model';
import { CommodityOfferBudgetbillProposalComponent } from '../commodity-offer-budgetbill-proposal/commodity-offer-budgetbill-proposal.component';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-commodity-offer-price-tag',
  templateUrl: './commodity-offer-price-tag.component.html',
  styleUrls: [
    './commodity-offer-price-tag.component.ed.scss',
    './commodity-offer-price-tag.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    CommodityOfferBudgetbillProposalComponent,
    RoundedCurrencyPipe,
  ],
})
export class CommodityOfferPriceTagComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public content?: CommodityOfferLabels;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public showBudgetbillProposal = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public termijnbedragVariantA = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public termijnbedragVariantB = false;

  /**
   * This discount infix should only be visible if the offer has a discount and if
   * there is a value available for the label
   */
  showMonthlyCostsLabelDiscountInfix() {
    return (
      this.offer?.incentiveTitle && this.content?.monthlyCostsLabelDiscountInfix
    );
  }

  monthlyCostLabelStyling() {
    if (this.termijnbedragVariantA) {
      return 'fw-bold';
    }

    if (this.termijnbedragVariantB) {
      return 'fw-bold variant-b';
    }

    return '';
  }
}
